export default __webpack_public_path__ + "cccd1c14cc6b3738864988ed0330996b.png";